import { Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
    MstRequest,
    DedupeConfigPagedList,
    DedupeConfigPayload,
    getAllDedupeConfig
} from 'api/master';
import { LoadingScreen } from 'common/components';
import { useEffect, useState } from 'react';
//import { useNavigate } from 'react-router-dom';

let dedupeconfigPagedList: DedupeConfigPagedList;
//let retryResponse: RetryResponse;

type Props = {
    filter: MstRequest;
    onSubmit: (values: DedupeConfigPayload) => Promise<void>;
};
const FundAccountList1 = ({ filter }: Props) => {
    //const navigate = useNavigate();
    //const [form] = Form.useForm<SourcePayload>();
    const [pagedList, setPagedList] = useState(dedupeconfigPagedList);
    //const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalLoading] = useState(false);
    //const [auditLog, setAuditLog] = useState(audit);
    const [_isRetry] = useState(false);
    //const [_retryRes, setRetryRes] = useState(retryResponse);
    //const [deleted, setDeleted] = useState(false);

    filter.userName = sessionStorage.getItem('user')?.toString();

    //const isAdmin = sessionStorage.getItem('isAdmin');

    useEffect(() => {
        setIsLoading(false);
        setPagedList(dedupeconfigPagedList);

        filter.pageNo = 1;
        filter.pageSize = 10;

        getAllDedupeConfig(filter)
            .then((res) => {
                setPagedList(res.data);
            })
            .finally(() => {
                setIsLoading(true);
            });
    }, [filter, _isRetry])


    const columns: ColumnsType<DedupeConfigPayload> = [
        {
            key: 'trailId',
            title: 'Trail Id',
            dataIndex: 'trailId',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
            className: '',
        },
        {
            key: 'configDate',
            title: 'Configuration Date',
            dataIndex: 'configDate',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'configBy',
            title: 'Configured By',
            dataIndex: 'configBy',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'dedupeStartDate',
            title: 'Dedupe Start Date',
            dataIndex: 'dedupeStartDate',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'dedupeEndDate',
            title: 'Dedupe End Date',
            dataIndex: 'dedupeEndDate',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
    ];


    // let payfilter: FilterPayload = {};
    if (!pagedList || !isLoading) {
        return <LoadingScreen />;
    }


    const handleChange = (_pagination: any, _filters: DedupeConfigPayload, sorter: any) => {
        setIsLoading(false);

        if (sorter.hasOwnProperty('column')) {
            // params.order = { field: sorter.field, dir: sorter.order };
        }


        filter.pageNo = _pagination.current;
        filter.pageSize = _pagination.pageSize;

        getAllDedupeConfig(filter).then((res) => {
            setPagedList(res.data);
            setIsLoading(true);
        });
    };

    const maxWidthPerCell = 1000;

    const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
    const tableHeight = 500;
    const rowKey = 'ROWNUM';

    return (
        <>
            <Spin spinning={isModalLoading}>
                <Table
                    columns={dataTable.columns}
                    dataSource={dataTable.source}
                    rowKey={rowKey}
                    scroll={{ x: dataTable.tableWidth, y: tableHeight }}
                    pagination={{
                        pageSize: 10,
                        total: pagedList.noOfRecords,
                        current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
                    }}
                    onChange={handleChange}
                />
            </Spin>
            ;
        </>
    );
};

export default FundAccountList1;
